var baseProperty = require('./_baseProperty');

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_asciiSize.js
// module id = 798
// module chunks = 4